import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../../i18n';

const copy = {
  it: {
    kicker: '404 fit check',
    title: 'Questo link non ha passato il vibe check.',
    body: 'La pagina non esiste, e onestamente anche l URL sembra uscito da uno scroll alle 3 di notte.',
    pathLabel: 'Route fantasma',
    cta: 'Torna al feed',
    secondary: 'Riparti da Outfit Detective e troviamo qualcosa che stia meglio.',
  },
  en: {
    kicker: '404 fit check',
    title: 'This link did not pass the vibe check.',
    body: 'The page is not here, and honestly this URL looks like it was typed during a 3 AM scroll.',
    pathLabel: 'Ghost route',
    cta: 'Back to the feed',
    secondary: 'Start from Outfit Detective again and let’s find something with better energy.',
  },
};

export default function NotFound() {
  const { language } = useI18n();
  const location = useLocation();
  const c = copy[language] || copy.en;

  return (
    <main className="ct-not-found-page">
      <section className="ct-not-found-card">
        <Link to="/" className="ct-not-found-brand" aria-label="Outfit Detective">
          <span className="ct-brand-mark image">
            <img src="/brand/outfit-detective-mark-transparent.svg" alt="" />
          </span>
          <span>Outfit Detective</span>
        </Link>
        <p className="ct-kicker">{c.kicker}</p>
        <h1>{c.title}</h1>
        <p>{c.body}</p>
        <div className="ct-not-found-route">
          <span>{c.pathLabel}</span>
          <code>{location.pathname}</code>
        </div>
        <Link to="/" className="ct-not-found-cta">
          <i className="ph ph-house"></i>
          <span>{c.cta}</span>
        </Link>
        <em>{c.secondary}</em>
      </section>
    </main>
  );
}
